import { sellTokenAddressEnum as y, ChainId as e, DOBAddressEnum as i, uHODLAddressEnum as m, USDCAddressEnum as E, sellTokenHODLAddressEnum as S, WETHAddressEnum as o } from "@deorderbook/contracts";
import { getTokenPrice as t } from "@deorderbook/backend-api";
import { chainId as d } from "../store/provider.mjs";
const U = (s) => {
  localStorage.setItem("DOB_RATE", String(s)), Number(localStorage.getItem("DOB_RATE"));
}, r = [
  {
    address: "0x0000000000000000000000000000000000000000",
    // zero address,
    symbol: "ETH",
    originalSymbol: "ETH",
    decimals: 18,
    USDExchangeRate: async () => await a("ETH")
  },
  {
    address: y[e.ETH_MAINNET],
    symbol: "sellToken",
    originalSymbol: "WBTC",
    decimals: 8,
    USDExchangeRate: async () => await a("sellToken")
  },
  {
    address: i[e.ETH_MAINNET],
    USDExchangeRate: async () => await a("DOB"),
    symbol: "DOB",
    originalSymbol: "DOB",
    decimals: 18
  },
  {
    address: m[e.ETH_MAINNET],
    symbol: "uHODL",
    originalSymbol: "uHODL",
    decimals: 18,
    USDExchangeRate: async () => await a("USDC")
  },
  {
    symbol: "USDC",
    originalSymbol: "USDC",
    decimals: 6,
    address: E[e.ETH_MAINNET],
    USDExchangeRate: async () => await a("USDC")
  },
  {
    address: S[e.ETH_MAINNET],
    USDExchangeRate: async () => await a("sellToken"),
    symbol: "sellTokenHODL",
    originalSymbol: "bHODL",
    decimals: 18
  },
  {
    symbol: "sellTokenBULLET",
    originalSymbol: "bBULLET",
    decimals: 18
  },
  {
    symbol: "uBULLET",
    originalSymbol: "uBULLET",
    decimals: 18
  },
  {
    symbol: "sellTokenSNIPER",
    originalSymbol: "bSNIPER",
    decimals: 18
  },
  {
    symbol: "uSNIPER",
    originalSymbol: "uSNIPER",
    decimals: 18
  },
  {
    address: o[e.ETH_MAINNET],
    USDExchangeRate: async () => await a("ETH"),
    symbol: "WETH",
    originalSymbol: "WETH",
    decimals: 18
  }
], b = [
  {
    address: "0x0000000000000000000000000000000000000000",
    // zero address,
    symbol: "ETH",
    originalSymbol: "ETH",
    decimals: 18,
    USDExchangeRate: async () => await a("ETH")
  },
  {
    address: y[e.ETH_SEPOLIA],
    symbol: "sellToken",
    originalSymbol: "WBTC",
    decimals: 8,
    USDExchangeRate: async () => await a("sellToken")
  },
  {
    address: i[e.ETH_SEPOLIA],
    symbol: "DOB",
    originalSymbol: "DOB",
    decimals: 18,
    USDExchangeRate: async () => await a("DOB")
  },
  {
    address: m[e.ETH_SEPOLIA],
    symbol: "uHODL",
    originalSymbol: "uHODL",
    decimals: 18,
    USDExchangeRate: async () => await a("USDC")
  },
  {
    address: E[e.ETH_SEPOLIA],
    symbol: "USDC",
    originalSymbol: "USDC",
    decimals: 6,
    USDExchangeRate: async () => await a("USDC")
  },
  {
    address: S[e.ETH_SEPOLIA],
    symbol: "sellTokenHODL",
    originalSymbol: "bHODL",
    decimals: 18,
    USDExchangeRate: async () => await a("sellToken")
  },
  {
    symbol: "sellTokenBULLET",
    originalSymbol: "bBULLET",
    decimals: 18
  },
  {
    symbol: "uBULLET",
    originalSymbol: "uBULLET",
    decimals: 18
  },
  {
    symbol: "sellTokenSNIPER",
    originalSymbol: "bSNIPER",
    decimals: 18
  },
  {
    symbol: "uSNIPER",
    originalSymbol: "uSNIPER",
    decimals: 18
  },
  {
    address: o[e.ETH_SEPOLIA],
    symbol: "WETH",
    originalSymbol: "WETH",
    decimals: 18,
    USDExchangeRate: async () => await a("ETH")
  }
], L = [
  {
    address: "0x0000000000000000000000000000000000000000",
    // zero address,
    symbol: "ETH",
    originalSymbol: "ETH",
    decimals: 18,
    USDExchangeRate: async () => await a("ETH")
  },
  {
    address: o[e.SCROLL_SEPOLIA],
    symbol: "sellToken",
    originalSymbol: "WETH",
    decimals: 18,
    USDExchangeRate: async () => await a("ETH")
  },
  {
    address: o[e.SCROLL_SEPOLIA],
    symbol: "WETH",
    originalSymbol: "WETH",
    decimals: 18,
    USDExchangeRate: async () => await a("ETH")
  },
  {
    symbol: "DOB",
    originalSymbol: "eDOB",
    address: i[e.SCROLL_SEPOLIA],
    USDExchangeRate: async () => await a("DOB"),
    decimals: 18
  },
  {
    address: m[e.SCROLL_SEPOLIA],
    symbol: "uHODL",
    originalSymbol: "uHODL",
    decimals: 18,
    USDExchangeRate: async () => await a("USDC")
  },
  {
    address: E[e.SCROLL_SEPOLIA],
    symbol: "USDC",
    originalSymbol: "USDC",
    decimals: 6,
    USDExchangeRate: async () => await a("USDC")
  },
  {
    address: S[e.SCROLL_SEPOLIA],
    USDExchangeRate: async () => await a("ETH"),
    symbol: "sellTokenHODL",
    originalSymbol: "eHODL",
    decimals: 18
  },
  {
    symbol: "sellTokenBULLET",
    originalSymbol: "eBULLET",
    decimals: 18
  },
  {
    symbol: "uBULLET",
    originalSymbol: "uBULLET",
    decimals: 18
  },
  {
    symbol: "sellTokenSNIPER",
    originalSymbol: "eSNIPER",
    decimals: 18
  },
  {
    symbol: "uSNIPER",
    originalSymbol: "uSNIPER",
    decimals: 18
  }
];
function g(s) {
  const l = {
    [e.ETH_MAINNET]: r,
    [e.ETH_SEPOLIA]: b,
    [e.SCROLL_SEPOLIA]: L
  };
  return s === void 0 ? n : l[s];
}
let n = r;
const c = (s) => (n = g(s), n);
function R(s) {
  return T(s)?.address;
}
function T(s) {
  return c(d).find((l) => l.symbol === s);
}
const u = (s) => c(d).find(
  (l) => l.symbol === s
)?.decimals;
function I(s) {
  return c(d).find(
    (l) => l?.address?.toLowerCase() === s.toLowerCase()
  );
}
const a = (s) => t(T(s).originalSymbol);
export {
  a as USDExchangeRate,
  U as changeDOBRate,
  I as getToken,
  R as getTokenAddressBySymbol,
  T as getTokenBySymbol,
  u as getTokenDecimals,
  g as getTokens,
  c as initTokens,
  n as tokens
};
//# sourceMappingURL=token.mjs.map
